import SearchIcon from '@mui/icons-material/Search';
import { Box, InputBase } from '@mui/material';
import React, { ReactElement } from 'react';

const BORDER_COLOR = '#DEDEDE';
const BG_COLOR = '#F0F0F0';
const PLACEHOLDER_COLOR = '#A7A7A7';
const TEXT_COLOR = '#383838';

export function PeopleSearchInput ({
  value,
  onChange,
  placeholder = 'Search members',
  fullWidth = false,
  width,
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  fullWidth?: boolean;
  width?: number | string;
}): ReactElement {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        border: `1px solid ${BORDER_COLOR}`,
        borderRadius: '8px',
        backgroundColor: BG_COLOR,
        height: 50,
        pl: '8px',
        pr: '16px',
        width: fullWidth ? '100%' : width ?? 320,
      }}
    >
      <SearchIcon sx={{ fontSize: 20, color: PLACEHOLDER_COLOR }} />
      <InputBase
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        sx={{
          flex: 1,
          fontFamily: '\'Poppins\', sans-serif',
          fontSize: '14px',
          color: TEXT_COLOR,
          '& input::placeholder': {
            color: PLACEHOLDER_COLOR,
            opacity: 1,
          },
        }}
      />
    </Box>
  );
}
